import { stringify } from '../components/utils/helpers';
const handleResponse = response => {
  const statusCode = response.status;
  const statusOK = statusCode >= 200 && statusCode < 300;
  const contentType = response.headers.get('content-type');
  const hasAPIReturnedValidJSON = (contentType === null || contentType === void 0 ? void 0 : contentType.indexOf('application/json')) !== -1;
  return response.json().then(data => {
    if (!response.ok) {
      const error = data && data.errors && [...data.errors] || `Error with status code ${statusCode}`;
      console.log('Received bad response');
      return Promise.reject(error);
    }
    if (!hasAPIReturnedValidJSON && statusOK) {
      return {
        statusCode
      };
    }
    return data; // if (response.ok)
  }).catch(err => {
    if (statusOK) {
      return {
        statusCode
      };
    } else {
      console.log('Caught error from request');
    }
    return false;
  });
};
export const fetchWrapper = async function (url, slug, userApiKey) {
  let method = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'GET';
  let data = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;
  const config = {
    method,
    headers: {
      'User-Api-Key': userApiKey,
      Accept: 'application/json'
    }
  };
  const methodsWithReqBody = ['POST', 'PUT', 'DELETE'];
  if (methodsWithReqBody.includes(method) && data) {
    config['body'] = stringify(data);
    config.headers['Content-Type'] = 'application/json';
  }
  return fetch(`${url}${slug}`, config).then(handleResponse);
};
export const fetchUploadFileWrapper = async (url, slug, userApiKey, formData) => {
  const headers = new Headers();
  headers.append('User-Api-Key', userApiKey);
  const config = {
    method: 'POST',
    headers,
    body: formData
  };
  return fetch(`${url}${slug}`, config).then(response => response.json()).then(result => {
    return result;
  }).catch(err => {
    console.log('Caught error while uploading file');
    return {};
  });
};
export const fetchLoginWrapper = async (url, data) => {
  const config = {
    method: 'POST',
    body: stringify(data),
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json'
    }
  };
  return fetch(`${url}/users/login`, config).then(handleResponse);
};
export const fetchPlatformInfo = async (url, user_id, user_auth_token) => {
  const config = {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
      Authorization: `Bearer ${user_auth_token}`
    }
  };
  return fetch(`${url}/users/${user_id}/profile`, config).then(handleResponse);
};
//# sourceMappingURL=index.js.map